import React, { useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import ButtonTheme from "../../ThemeButton/ThemeButton";
import ConfModal from "../../Modal/ConfModal";
import MyTable from "../../Schedule/MyTable";
import { getGridStringOperators } from "@mui/x-data-grid";
import PaginationComponent from "../../Pagination/Pagination";
import ApiService from "../../../functions/apiService";
import { toast } from 'react-toastify';

export default function Accruals() {
  // const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  let loadData = (page = 1) => {
    ApiService.get("/getAccruals", { page }, "getAccruals")
      .then(({ data }) => {
        setLoading(false);
        console.log("data", data.data);
        Object.values(data.data).map((i) => console.log("data item", i));
        setModalData(data);
        setOpen(true);
        toast.success('Success')
        // enqueueSnackbar("success", { variant: "success" });
      })
      .catch(({ data }) => {
        setLoading(false);
        toast.error('Error')
        // enqueueSnackbar("Error", { variant: "error" });
      });
  };
  const onSubmit = () => {
    setLoading(true);
    loadData();
  };
  let columns = [
    {
      field: "ET_Subtype_Name",
      headerName: "Type",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "ET_Date",
      headerName: "Date",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "ET_Total",
      headerName: "Start",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "Accrued",
      headerName: "Accrued",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "CARRYOVER",
      headerName: "CARRYOVER",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
    {
      field: "SOLD",
      headerName: "SOLD",
      flex: 1,
      minWidth: 120,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
    },
  ];
  let closeModal = () => {
    setOpen(false);
  };
  let pageChanged = (e, page) => {
    console.log("page", page);
  };
  return (
    <>
      <Typography fontWeight="700" fontSize="16px">
        Accruals
      </Typography>

      <div className="col-12 mt-2">
        <ButtonTheme onClick={onSubmit} color="primary" disabled={loading}>
          {loading ? "Loading" : "View Accruals"}
        </ButtonTheme>
      </div>
      <ConfModal Title="Employees" open={open} closeModal={closeModal}>
        {modalData && modalData.data && modalData.data.length > 0 && (
          <div>
            {Object.values(modalData.data).map((i) => (
              <div key={i.id}>
                <p class="h4 my-2">{i.EmpName}</p>
                <MyTable
                  rows={Object.values(i.data)}
                  columns={columns}
                  useTopFilter={false}
                  checkboxSelection={false}
                  hideFooter={true}
                />
              </div>
            ))}
          </div>
        )}
        <PaginationComponent
          results={modalData.pagination}
          pageChanged={pageChanged}
        />
      </ConfModal>
    </>
  );
}
